import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import { Page, Header } from 'components';
import PCIsReportUpload from './PCIsReport/PCIsReportUpload';
import PCIsTemplate from './PCIsTemplate/PCIsTemplate';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const PCIsReport = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="PCIs Report">
			<Header module="PCIs Report" view="PCIs Report" />
			<PCIsTemplate />
			<PCIsReportUpload className={classes.content} />
		</Page>
	);
};

export default PCIsReport;
